import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import policyService from "./policyService";
import { flashMessage as flash } from "../../../utils/flash";
// import { current } from "@reduxjs/toolkit";

const initialState = {
  isError: false,
  isLoading: false,
  isSuccess: false,
  isUpdated: false,
  isPolicyEdited: false,
  isFiltering: false,
  isFiltered: false,
  policyConfig: null,
  single_policy: null,
  active_policy: {},
  risk_covered: null,
  cover: null,
  unpaginated_applied_policy: null,
  unpaginated_policy: null,
  customer_policy_details: null,
  customer_policies: null,
  temp_policy_attach_data: null,
  applied_policies: null,
  customer_active_policy: null,
  single_policy_cover: null,
  policy_circles: null,
  policy_history_details: null,
};

const policySlice = createSlice({
  initialState,
  name: "policy",
  reducers: {
    resetPolicy: (state) => initialState,
    resetPolicyStatus: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.isUpdated = false;
      state.isFiltered = false;
      state.isFiltering = false;
      state.isPolicyEdited = false;
      state.message = "";
    },
    resetSinglePolicy: (state) => {
      state.single_policy = null;
    },
    resetSinglePolicyCover: (state) => {
      state.single_policy_cover = null;
    },
    resetSinglePolicyHistory: (state) => {
      state.policy_history_details = null;
    },
    setRiskCover: (state, { payload }) => {
      const newRisk = state.risk_covered?.findIndex(
        (item) => item.id === payload.id
      );
      if (newRisk >= 0) {
        state.risk_covered[newRisk] = payload;
      } else {
        state.risk_covered = [...state.risk_covered, payload];
      }
    },
    attachPolicy: (state, { payload }) => {
      state.temp_policy_attach_data = payload;
    },
    deleteRiskCover: (state, { payload }) => {
      const risks = state.risk_covered.filter((item) => item.id !== payload);
      state.risk_covered = risks;
    },
    resetRiskCover: (state, { payload }) => {
      state.risk_covered = [];
    },
    resetActivePolicies: (state) => {
      state.active_policy = {};
    },
    resetAttachedPolicyPreview: (state) => {
      state.risk_covered = [];
      state.temp_policy_attach_data = null;
      state.single_policy = null;
    },
    resetCustomerSinglePolicyDetailsView: (state) => {
      state.customer_policy_details = null;
    },
    resetCustomerPolicies: (state) => {
      state.customer_policies = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPolicyConfig.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Creating Policy");
      })
      .addCase(createPolicyConfig.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.errors) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(createPolicyConfig.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      .addCase(getAllPolicies.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllPolicies.fulfilled, (state, action) => {
        state.isLoading = false;
        state.unpaginated_policy = action.payload.unpaginatedPolicy;
        state.policyConfig = action.payload;
      })
      .addCase(getAllPolicies.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      .addCase(getAllActivePolicies.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllActivePolicies.fulfilled, (state, action) => {
        state.isLoading = false;
        state.active_policy = action.payload;
      })
      .addCase(getAllActivePolicies.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      .addCase(getAllActiveSavingsPolicies.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllActiveSavingsPolicies.fulfilled, (state, action) => {
        state.isLoading = false;
        state.active_policy.policy = action.payload.savings_policy;
      })
      .addCase(getAllActiveSavingsPolicies.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      .addCase(getFilteredPolicies.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getFilteredPolicies.fulfilled, (state, action) => {
        state.isLoading = false;
        state.policyConfig = action.payload;
      })
      .addCase(getFilteredPolicies.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      .addCase(getPolicy.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPolicy.fulfilled, (state, action) => {
        state.isLoading = false;
        state.single_policy = action.payload;
      })
      .addCase(getPolicy.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", "Policy cannot be accessed");
      })
      .addCase(viewCustomerPolicies.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(viewCustomerPolicies.fulfilled, (state, action) => {
        state.isLoading = false;
        state.customer_policies = action.payload;
      })
      .addCase(viewCustomerPolicies.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      // attach policy to customer
      .addCase(attachPolicyToCustomer.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Attaching policy");
      })
      .addCase(attachPolicyToCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isUpdated = true;
        state.customer_policy_details = action.payload;
        if (action.payload.error) {
          flash("error", action.payload.error);
        }
        if (action.payload.message) {
          flash("success", action.payload.message);
        }
      })
      .addCase(attachPolicyToCustomer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.error);
      })
      .addCase(deleteCover.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteCover.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isUpdated = true;
        state.isSuccess = true;
        flash("success", "Cover deleted successfully");
      })
      .addCase(deleteCover.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      .addCase(updatePolicy.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePolicy.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.errors) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(updatePolicy.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      .addCase(getAppliedPolicies.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAppliedPolicies.fulfilled, (state, action) => {
        state.isLoading = false;
        state.applied_policies = action.payload;
        state.unpaginated_applied_policy =
          action.payload.unpaginated_applied_policy;
        if (!action.payload.errors) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getAppliedPolicies.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload.message);
      })
      // get all filtered applied policies
      .addCase(FilteredAppliedPolicies.pending, (state) => {
        state.isLoading = true;
        state.isFiltering = true;
        flash("loading", "Filtering data...");
      })
      .addCase(FilteredAppliedPolicies.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isFiltered = true;
        state.isFiltering = false;
        state.applied_policies = payload;
        if (payload.errors) {
          flash("error", payload.errors);
        } else {
          flash("success", payload.message);
        }
      })
      .addCase(FilteredAppliedPolicies.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isFiltering = false;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // get all searched applied policies
      .addCase(searchAppliedPolicies.pending, (state) => {
        state.isLoading = true;
        state.isFiltering = true;
        flash("loading", "Filtering data...");
      })
      .addCase(searchAppliedPolicies.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isFiltered = true;
        state.isFiltering = false;
        state.applied_policies = payload;
        if (payload.errors) {
          flash("error", payload.errors);
        } else {
          flash("success", payload.message);
        }
      })
      .addCase(searchAppliedPolicies.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isFiltering = false;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // get single policy details for a particular customer
      .addCase(getSinglePolicyDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSinglePolicyDetails.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.customer_policy_details = payload;
        if (payload.errors) {
          flash("error", payload.errors);
        }
      })
      .addCase(getSinglePolicyDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isFiltering = false;
        state.message = action.payload;
        flash("error", action.payload);
      })
      .addCase(getSinglePolicyHistory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSinglePolicyHistory.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.policy_history_details = payload;
        if (payload.errors) {
          flash("error", payload.errors);
        }
      })
      .addCase(getSinglePolicyHistory.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isFiltering = false;
        state.message = action.payload;
        flash("error", action.payload);
      })
      .addCase(getSingleAppliedPolicyDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSingleAppliedPolicyDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.single_policy = action.payload;
      })
      .addCase(getSingleAppliedPolicyDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getSingleAppliedPolicyCovers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSingleAppliedPolicyCovers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.single_policy_cover = action.payload;
      })
      .addCase(getSingleAppliedPolicyCovers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getSinglePolicyCover.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSinglePolicyCover.fulfilled, (state, action) => {
        state.isLoading = false;
        state.single_policy_cover = action.payload.policy_cover;
      })
      .addCase(getSinglePolicyCover.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", "There is no cover attached to this policy");
      })
      .addCase(editAttachPolicy.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Updating policy attachment");
      })
      .addCase(editAttachPolicy.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isUpdated = true;
        state.customer_policy_details = action.payload;
        state.isPolicyEdited = true;
        if (action.payload.error) {
          flash("error", action.payload.error);
        }
        if (action.payload.message) {
          flash("success", action.payload.message);
        }
      })
      .addCase(editAttachPolicy.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(renewPolicyToCustomer.pending, (state) => {
        state.isLoading = true;
        flash("loading", "renewing policy");
      })
      .addCase(renewPolicyToCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isUpdated = true;
        state.customer_policy_details = action.payload;
        state.isPolicyEdited = true;
        if (action.payload.error) {
          flash("error", action.payload.error);
        }
        if (action.payload.message) {
          flash("success", action.payload.message);
        }
      })
      .addCase(renewPolicyToCustomer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getPolicyCoverByCategory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPolicyCoverByCategory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cover = action.payload;
      })
      .addCase(getPolicyCoverByCategory.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })

      // .addCase(getPolicyScheduleDoc.pending, (state) => {
      //   state.isLoading = true;
      // })
      // .addCase(getPolicyScheduleDoc.fulfilled, (state, { payload }) => {
      //   state.isLoading = false;
      //   state.isSuccess = false;
      //   state.underwritingData = payload;
      // })
      // .addCase(getPolicyScheduleDoc.rejected, (state, action) => {
      //   state.isLoading = false;
      //   state.isError = true;
      // })
      .addCase(getPolicyHistoryCircle.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPolicyHistoryCircle.fulfilled, (state, action) => {
        state.isLoading = false;
        state.policy_circles = action.payload;
      })
      .addCase(getPolicyHistoryCircle.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

// create policy
export const createPolicyConfig = createAsyncThunk(
  "createPolicyConfig",
  async (DATA, thunkAPI) => {
    try {
      return await policyService.createPolicyConfig(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get filtered policies
export const getFilteredPolicies = createAsyncThunk(
  "getFilteredPolicies",
  async (DATA, thunkAPI) => {
    try {
      return await policyService.getFilteredPolicies(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// export const get all policies
export const getAllPolicies = createAsyncThunk(
  "getAllPolicies",
  async (DATA, thunkAPI) => {
    try {
      return await policyService.getAllPolicies(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// export const get all active policies
export const getAllActivePolicies = createAsyncThunk(
  "getAllActivePolicies",
  async (data, thunkAPI) => {
    try {
      return await policyService.getAllActivePolicies(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
//  get all active savings policies
export const getAllActiveSavingsPolicies = createAsyncThunk(
  "getAllActiveSavingsPolicies",
  async (data, thunkAPI) => {
    try {
      return await policyService.getAllActiveSavingsPolicies(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// get a single policy by id
export const getPolicy = createAsyncThunk(
  "getPolicy",
  async (payload, thunkAPI) => {
    try {
      return await policyService.getPolicy(payload);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get a single policy by id
export const updatePolicy = createAsyncThunk(
  "updatePolicy",
  async (data, thunkAPI) => {
    try {
      return await policyService.updatePolicy(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// delete a single policy's cover by id
export const deleteCover = createAsyncThunk(
  "deleteCover",
  async (data, thunkAPI) => {
    try {
      return await policyService.deleteCover(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//attach the policy to a customer
export const attachPolicyToCustomer = createAsyncThunk(
  "attachPolicyToCustomer",
  async (data, thunkAPI) => {
    try {
      return await policyService.attachPolicyToCustomer(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//attach the policy to a customer
export const getAppliedPolicies = createAsyncThunk(
  "getAppliedPolicies",
  async (data, thunkAPI) => {
    try {
      return await policyService.getAppliedPolicies(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
//filter all applied policies
export const FilteredAppliedPolicies = createAsyncThunk(
  "FilteredAppliedPolicies",
  async (data, thunkAPI) => {
    try {
      return await policyService.FilteredAppliedPolicies(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
//search for an applied policy
export const searchAppliedPolicies = createAsyncThunk(
  "searchAppliedPolicies",
  async (data, thunkAPI) => {
    try {
      return await policyService.searchAppliedPolicies(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
//search for an applied policy
export const viewCustomerPolicies = createAsyncThunk(
  "view-CustomerPolicy-Detail",
  async (data, thunkAPI) => {
    try {
      return await policyService.viewCustomerPolicies(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
//get single policy details for a particular customer
export const getSinglePolicyDetails = createAsyncThunk(
  "getSinglePolicyDetails",
  async (data, thunkAPI) => {
    try {
      return await policyService.getSinglePolicyDetails(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
//get single policy history details for a particular customer
export const getSinglePolicyHistory = createAsyncThunk(
  "getSinglePolicyHistory",
  async (data, thunkAPI) => {
    try {
      return await policyService.getSinglePolicyHistory(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get all applied policies for editing
export const getSingleAppliedPolicyDetails = createAsyncThunk(
  "getSingleAppliedPolicyDetails",
  async (data, thunkAPI) => {
    try {
      return await policyService.getSingleAppliedPolicyDetails(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// get all applied policies for editing
export const getSingleAppliedPolicyCovers = createAsyncThunk(
  "getSingleAppliedPolicyCovers",
  async (policy_number, thunkAPI) => {
    try {
      return await policyService.getSingleAppliedPolicyCovers(policy_number);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// edit applied policy
export const editAttachPolicy = createAsyncThunk(
  "editAttachPolicy",
  async (data, thunkAPI) => {
    try {
      return await policyService.editAttachPolicy(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// renew applied policy
export const renewPolicyToCustomer = createAsyncThunk(
  "renewPolicyToCustomer",
  async (data, thunkAPI) => {
    try {
      return await policyService.renewPolicyToCustomer(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// policy cover
export const getSinglePolicyCover = createAsyncThunk(
  "getSinglePolicyCover",
  async (data, thunkAPI) => {
    try {
      return await policyService.getSinglePolicyCover(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// policy cover
export const getPolicyCoverByCategory = createAsyncThunk(
  "getPolicyCoverByCategory",
  async (data, thunkAPI) => {
    try {
      return await policyService.getPolicyCoverByCategory(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// export const getPolicyScheduleDoc = createAsyncThunk(
//   "getPolicyScheduleDoc",
//   async (DATA, thunkAPI) => {
//     try {
//       return await policyService.getPolicyScheduleDoc(DATA);
//     } catch (error) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue(message);
//     }
//   }
// );
// get policy history circle
export const getPolicyHistoryCircle = createAsyncThunk(
  "getPolicyHistoryCircle",
  async (data, thunkAPI) => {
    try {
      return await policyService.getPolicyHistoryCircle(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const {
  resetPolicy,
  resetPolicyStatus,
  resetSinglePolicy,
  setRiskCover,
  resetRiskCover,
  resetSinglePolicyCover,
  deleteRiskCover,
  attachPolicy,
  resetActivePolicies,
  resetAttachedPolicyPreview,
  resetCustomerSinglePolicyDetailsView,
  resetCustomerPolicies,
  resetSinglePolicyHistory,
} = policySlice.actions;
export default policySlice.reducer;

// selectors
export const allActivePolicies = (state) => state.policy.active_policy;
